import { useState } from "react";
import { creditos } from "../lib/formato";
import { useIdioma } from "../lib/idioma";

/**
 * Cuánto hay que devolver.
 *
 * En el mostrador la cuenta se hace de cabeza y con prisa, y equivocarse al
 * devolver el cambio descuadra el arqueo de la noche sin que nadie sepa por
 * qué. Aquí se toca lo que el socio ha puesto encima y sale la vuelta sola.
 *
 * No obliga a usarla: quien tenga la cuenta hecha cobra y sigue. Es una ayuda,
 * no un paso más.
 */

/** Monedas y billetes de euro, en céntimos. */
const MONEDAS = [1, 2, 5, 10, 20, 50, 100, 200];
const BILLETES = [500, 1000, 2000, 5000, 10000, 20000, 50000];

export default function CalculadoraCambio({ aCobrarCentimos }: { aCobrarCentimos: number }) {
  const { t } = useIdioma();
  const [entregadoCentimos, setEntregado] = useState(0);
  const [aMano, setAMano] = useState("");

  const cambio = entregadoCentimos - aCobrarCentimos;
  const falta = cambio < 0;

  return (
    <div className="cambio">
      <div className="cambio-cuentas">
        <div>
          <span className="suave pequeno">{t("cc.entregado")}</span>
          <strong className="tabular">{creditos(entregadoCentimos)}</strong>
        </div>
        <div>
          <span className="suave pequeno">{t("cc.aCobrar")}</span>
          <strong className="tabular">{creditos(aCobrarCentimos)}</strong>
        </div>
        <div>
          <span className="suave pequeno">{t("cc.cambio")}</span>
          {/* Antes de cubrir el importe no hay cambio que devolver, hay dinero
              que falta: decirlo así evita devolver de menos sin darse cuenta. */}
          <strong className={`tabular${falta ? " falta" : ""}`}>
            {entregadoCentimos === 0
              ? "—"
              : falta
                ? t("cc.faltan", { importe: creditos(-cambio) })
                : creditos(cambio)}
          </strong>
        </div>
      </div>

      <div className="cambio-piezas">
        {[...MONEDAS, ...BILLETES].map((c) => (
          <button
            key={c}
            type="button"
            className="boton secundario"
            onClick={() => setEntregado((e) => e + c)}
          >
            {creditos(c)}
          </button>
        ))}
      </div>

      <div className="fila" style={{ marginTop: 10 }}>
        <input
          type="number"
          step="0.01"
          min={0}
          value={aMano}
          onChange={(e) => setAMano(e.target.value)}
          placeholder={t("cc.oEscribelo")}
          style={{ maxWidth: 140 }}
        />
        <button
          type="button"
          className="boton secundario"
          disabled={!(Number(aMano) > 0)}
          onClick={() => {
            setEntregado(Math.round(Number(aMano) * 100));
            setAMano("");
          }}
        >
          {t("cc.poner")}
        </button>
        <button
          type="button"
          className="boton fantasma"
          disabled={entregadoCentimos === 0}
          onClick={() => setEntregado(0)}
        >
          {t("cc.empezarDeNuevo")}
        </button>
      </div>
    </div>
  );
}
